
@if (!!spec) {
  @if (showIcon) {
    <fa-icon class="info-icon" [icon]="faCheckSquare"></fa-icon>
  }
  <div class="spec-title">{{(spec.displayId || "") + " " + spec.title}}</div>
}
@if (!spec && !isError) {
  <div class="spec-title loading"><fa-icon [icon]="faSyncAlt" [spin]="true"></fa-icon></div>
}
@if (!spec && isError) {
  <div class="spec-title">Unknown spec</div>
}
